(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jhd-numbered-drop"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.jhd-numbered-drop').forEach((drop) => {
    if (drop.dataset.mediaIntentReady === 'true') return;
    drop.dataset.mediaIntentReady = 'true';
    const hydrate = (target) => {
      const media = target.closest('.jhd-numbered-drop__act-media');
      const image = media && media.querySelector('[data-drop-model-src]');
      if (!image || image.getAttribute('src')) return;
      image.setAttribute('src', image.dataset.dropModelSrc);
    };
    drop.addEventListener('pointerover', (event) => hydrate(event.target));
    drop.addEventListener('focusin', (event) => hydrate(event.target));
    const mediaObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const media = entry.target;
        if (entry.isIntersecting) hydrate(media);
        window.clearTimeout(media.jhdModelRevealTimer);
        if (entry.intersectionRatio >= .58) {
          media.jhdModelRevealTimer = window.setTimeout(() => {
            media.classList.add('is-model-visible');
          }, 420);
        } else if (entry.intersectionRatio < .28) {
          media.classList.remove('is-model-visible');
        }
      });
    }, { threshold: [0, .28, .58] });
    drop.querySelectorAll('.jhd-numbered-drop__act-media').forEach((media) => mediaObserver.observe(media));

    const grid = drop.querySelector('.jhd-numbered-drop__grid');
    const mobileCta = drop.querySelector('[data-drop-mobile-cta]');
    if (grid && mobileCta) {
      const ctaObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => mobileCta.classList.toggle('is-hidden', entry.isIntersecting));
      }, { rootMargin: '0px 0px -35% 0px', threshold: 0 });
      ctaObserver.observe(grid);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
